import script from "./xq.vue?vue&type=script&setup=true&lang=js"
export * from "./xq.vue?vue&type=script&setup=true&lang=js"

import "./xq.vue?vue&type=style&index=0&id=7e2e3e82&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2e3e82"]])

export default __exports__